import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postWorkOrderSignature({ body }) {
  return BaseService.post(REST.WORK_ORDER_SIGNATURE, body);
}

function putWorkOrderSignature({ body, id }) {
  return BaseService.put(REST.WORK_ORDER_SIGNATURE_ID(id), body);
}

function getWorkOrderSignatures(params) {
  return BaseService.get(REST.WORK_ORDER_SIGNATURE, {
    params: paramsFilter({ params }),
  });
}

function deleteWorkOrderSignature({ id }) {
  return BaseService.delete(REST.WORK_ORDER_SIGNATURE_ID(id));
}

export default {
  postWorkOrderSignature,
  putWorkOrderSignature,
  getWorkOrderSignatures,
  deleteWorkOrderSignature,
};
